import { Component } from '@angular/core';
import {
  DynamicFormField,
  fieldGroup,
  formBuilder,
  select,
} from '@kinet-open-network/client/core/forms/ui';
import {
  AutomationRuleOperator,
  IAutomationRule,
  createEnumList,
  deliveryTypeOptions,
} from '@kinet-open-network/shared/data-access/model';
import { FormlyModule } from '@ngx-formly/core';
import { RULE_TEMPLATE, RuleComponent } from './abstract-rule.component';

@Component({
  imports: [FormlyModule],
  selector: 'kon-invoice-delivery-type-rule',
  template: RULE_TEMPLATE,
})
export class InvoiceDeliveryTypeRuleComponent extends RuleComponent {
  override defaultModel: Partial<IAutomationRule> = {
    operator: AutomationRuleOperator.Equals,
  };

  override fields: DynamicFormField[] = formBuilder(
    fieldGroup()
      .fieldGroupClassName(`grid grid-cols-3 gap-2`)
      .fieldGroup([
        this.ruleSelectField,
        select('operator')
          .options([
            {
              label: 'je',
              value: AutomationRuleOperator.Equals,
            },
            {
              label: 'nie je',
              value: AutomationRuleOperator.NotEquals,
            },
          ])
          .wrappers([]),
        select('value', '')
          .options(createEnumList(deliveryTypeOptions))
          .required()
          .wrappers([]),
      ]),
  );
}
